<template>
  <div>
    <DaiBarrasAgrupadasV2
    :titulo="encabezado"
    :instruccional="'Última actualización: '+fechaActualizacion"
    :datos="datosGrafica"
    :variables="variablesGrafica"
    :nombre_variables="{nombre:'nombre'}"
    :orientacion="screenIsMobile &&
      this.$store.getters.estadoSeleccionado === '00'
      ? 'vertical' : 'horizontal'"
    titulo_leyenda="Estado de los pacientes"
    />
  </div>
</template>

<script>
import DaiBarrasAgrupadas from '@/components/utils/BarrasAgrupadas.vue';
import consorcioStatus from '@/assets/datasets/consorcio_estatus.json';
import diccionarioColores from '@/assets/data/diccionario-colores.json';
import DaiBarrasAgrupadasHorizontales from '@/components/utils/BarrasAgrupadasHorizontales.vue';
import DaiBarrasAgrupadasV2 from '@/components/utils/BarrasAgrupadasv2.vue';

const dictValuesStatus = {
  ambulatorio: 'Ambulatorio',
  dado_alta: 'Dado de alta',
  hospitalizado: 'Hospitalizado',
  sin_info: 'Sin asignar',
  fallecido: 'Fallecido',
  vivo: 'Vivo',
};
const dictColorsStatus = {
  ambulatorio: '#23D0E8',
  dado_alta: '#0E728D',
  hospitalizado: '#2BFED1',
  sin_info: '#6D8798',
  fallecido: '#0E3930',
  vivo: '#30A1E8',
};
/* eslint-disable */
const variables = Object.entries(dictValuesStatus).map((status) => {
  return {
    color:dictColorsStatus[status[0]],
    id:status[0],
    nombre : status[1],
  };
});

// preparando diccionario general nacional
const diccionarioNacional = consorcioStatus.reduce((acum, current) => {
  const acum2 = { ...acum };
  // console.log(acum2);
  if (!(current.cve_edo in acum2)) {
    acum2[current.cve_edo] = {};
    acum2[current.cve_edo].nombre = current.abrev;
    acum2[current.cve_edo].estado = current.estado;
    Object.keys(diccionarioColores).forEach((key) => {
      acum2[current.cve_edo][key] = {};
      Object.entries(dictValuesStatus).forEach((entrie) => {
        acum2[current.cve_edo][key][entrie[0]] = 0;
      });
    });
  }
  // sumar a donde va
  const keyStatus = Object.keys(dictValuesStatus).find(
    (key) => dictValuesStatus[key] === current.estatus_paciente,
  );

  acum2[current.cve_edo][current.tipo_variante][keyStatus] += current.cantidad_muestras;
  return acum2;
}, {});

export default {
  components: {
    DaiBarrasAgrupadas,
    DaiBarrasAgrupadasHorizontales,
    DaiBarrasAgrupadasV2
  },
  data() {
    return {
      diccionarioDatos: diccionarioNacional,
      variables:variables,
      //variablesGrafica: variables,
      screenIsMobile:false
    };
  },
  computed: {
    fechaActualizacion() {
      return this.$store.getters.fechaActualizacion;
    },
    datosGrafica() {
      //solo mandar los datos de un estado
      if(this.$store.getters.estadoSeleccionado !== '00'){
        const vars = {...this.diccionarioDatos[this.$store.getters.estadoSeleccionado][this.$store.getters.varianteSeleccionada] };
        vars.nombre = this.diccionarioDatos[this.$store.getters.estadoSeleccionado].nombre;
        return [vars]
      }
      //en otro caso mandar todos los estados
      //ordenar de mayor a menor (eso ya se hace dentro del componente)

      return Object.values(this.diccionarioDatos).map((entrie) => {
        const edos = { ...entrie[this.$store.getters.varianteSeleccionada] };
        /* eslint-disable */
        edos.nombre = entrie.nombre;
        edos.estado = entrie.estado;
        return edos;
      });
    },
    encabezado() {
      const varianteSeleccion = this.$store.getters.varianteSeleccionada;
      // const estadoSeleccion = this.$store.getters.estadoSeleccionado;
      let titleVariante = 'variantes del virus SARS-CoV-2';
      if (varianteSeleccion !== 'VTODAS'){
        titleVariante = diccionarioColores[varianteSeleccion].title2;
        titleVariante = `variantes ${titleVariante}`;
      }

      return `Estado de salud de la muestra de pacientes diagnosticados con alguna de las ${titleVariante} `;
    },
    variablesGrafica() {
      if(this.$store.getters.estadoSeleccionado !== '00'){
        const datos1Estado = {...this.diccionarioDatos[this.$store.getters.estadoSeleccionado][this.$store.getters.varianteSeleccionada] };
        return Object.entries(datos1Estado).sort((a,b)=>b[1] - a[1]).map(item=>{
          return {
            color:dictColorsStatus[item[0]],
            id:item[0],
            nombre : dictValuesStatus[item[0]],
          }
        })

      }
      return this.variables
    }

  },
  mounted() {
    this.screenIsMobile = checkIfIsMobile();
    window.addEventListener("resize",()=>{
      this.screenIsMobile = checkIfIsMobile();
    })
  }
};


const checkIfIsMobile=()=>{
  return window.innerWidth <= 769
}
</script>

<style lang="scss">
  .titulo-proyecto {
    padding: 10px 10px 0px 10px;
    text-align: right;
    font-size: 14px;
    display: inherit;
  }
  .titulo-visualizacion {
    font-size: 16px;
    padding: 10px;
    margin: 0;
  }
  p.instruccional{
    font-size: 12px;
    padding: 0 10px;
    margin: 5px 0;
  }
</style>
